import { Referrer } from '../models/Referrer'

export const REFERRER_HEINEKEN = 'heineken'
export const REFERRER_ATP = 'atp'
export const REFERRER_DEFAULT = 'default'

export const isGuidedOnboarding = (referrer?: Referrer) => !!referrer && referrer.isGuidedOnboarding
